module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.c7dcce08.ttf";